<template>
  <div class="root">
    <div class="main">
      <div style="display: flex;" v-if="false">
        <span>
          报警类型
        </span>
        <div style="border:1px solid rgb(228, 228, 228);padding-top: 10px;padding-left: 12px;">
          <el-select
            v-model="perSonnelType"
            multiple
            collapse-tags
            placeholder="请选择">
            <el-option
              v-for="item in personnelTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div style="display: flex;">
        <span>
          接收方式
        </span>
        <div style="border:1px solid rgb(228, 228, 228);padding-top: 16px;padding-left: 20px;">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="1">短信</el-checkbox>
            <el-checkbox label="2">语音</el-checkbox>
            <el-checkbox label="3">公众号</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div style="display: flex;">
        <span>
          接收人员
        </span>
        <div style="border:1px solid rgb(228, 228, 228);padding-left: 15px;padding-top: 7px;">
          <el-select
            v-model="perList"
            multiple
            collapse-tags
            placeholder="请选择">
            <el-option
              v-for="item in personnelList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div style="color:rgb(255, 153, 0);margin-top: 10px;">
      提示：接收人员配置为当前设置，人员数据来源项目成员，可多选.
    </div>
  </div>
</template>

<script>
import {url} from '@/utils/config'
import {postFun} from '@/utils/httpFun'
export default {
  props:{
      data:{
        type:Object,
        default:()=>{}
      },
      policeList:{
        type:Array,
        default:()=>[]
      },
      tableSelect:{
        type:Array,
        default: () =>[]
      }
  },
  data(){
    return {
      checkList:[],
      personnelList:[],
      perList:[],
      perSonnelType:[],
      personnelTypeList:[],
      enabled:true
    }
  },
  mounted(){
    this.personnelList = this.policeList;
  },
  methods:{
    async add() {
      console.log('打印贴纸', this.personnelList);
      if(this.checkList == 0){
        this.$message.warning("请选择推送方式");
        return;
      }
      if(this.perList.length == 0){
        this.$message.warning("请选择人员");
        return;
      }

      this.perList.forEach((item,index)=>{
        this.personnelList.forEach(items=>{
          if(item == items.id){
            this.perList[index] = {
              "userId":items.id,
              "userName":items.name,
              "phone":items.phone,
              "shortMessageState":items.shortMessageState,
              "oaState":items.oaState,
              "voiceState":items.voiceState
            };
          }
        })
      })

      let pushConfigDeviceList = [];

      this.tableSelect.forEach((item, index) => {
        let obj = {
          deviceId:item.deviceConfig.deviceId,
          oaState:false,
          shortMessageState:false,
          voiceState:false
        }
        console.log("多选择",this.tableSelect)

        this.checkList.forEach((items)=>{
          switch(items){
            case "1":
              obj.shortMessageState = true;
            break;
            case "2":
              obj.voiceState = true;
            break;
            case "3":
              obj.oaState = true;
            break;
          }
        })
        pushConfigDeviceList.push(obj);
      })

      let param = {
        "pushConfigDeviceList":pushConfigDeviceList,
        "pushUserList":this.perList
      }
      await postFun(url.PROJECT.ADDBATCHDEV,param,res=>{
        if(res.data){
          this.$message.success("设置成功");
          // this.$bus.$emit("Close");
        }else{
          this.$message.warning("设置失败")
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .title{
    display: flex;
    div{
      width: 307px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .main{
    margin-top: 25px;
    border:1px solid rgb(228, 228, 228);
    div{
      width: 100%;
      // display: flex;
      span{
        height: 55px;
        width: 79px;
        display: flex;
        justify-content: center;
        align-items:center;
        background-color: rgb(242, 242, 242);
        border:1px solid rgb(228, 228, 228);
      }
      div{
        // padding-top: 4px;
        // padding-left: 10px;
      }
    }
    .money{
      color: #fff;
      background-color: rgb(255, 153, 0);
      width: 80px;
      padding-left: 16px;
      margin-bottom: 3px;
      margin-right: 10px;
      border-radius: 10px;
    }
  }
</style>